import { RiderVehicleTypeEnum, ColorTypeEnum, BoundaryFeeModel } from 'app/models';

export class OperatorVehicleModel {
    Id!: number;
    VehicleType!: RiderVehicleTypeEnum;
    VehicleTypeText!: string;
    VehicleBrandId!: number;
    VehicleBrandName!: string;
    VehicleModelId!: number;
    VehicleModelName!: string;
    NumberPlate!: string;
    BoundaryAmount!: number;
    IsOwner!: boolean;
    VehicleYear!: number;
    VehicleColor!: ColorTypeEnum;
    VehicleColorText!: string;
    PaOrCpcCaseNumber!: string;
    IsActive!: boolean;
    Status?: string;
    VehicleFrontImageUrl?: string;
    AssignedDriverNames?: string[];

    BoundaryFeeModel!: BoundaryFeeModel;

    constructor(payload?: { [key: string]: any }) {
        Object.assign(this, payload);
        this.BoundaryFeeModel = new BoundaryFeeModel(this.BoundaryFeeModel);
    }
}
